const translations = {
  page_title: 'Costs',

  // Table columns
  reference_number: 'Ref Number',
  notes: 'Notes',
  vehicle: 'Vehicle',
  category: 'Category',
  supplier: 'Supplier',
  created: 'Created',
  invoice: 'Invoice',
  cost: 'Cost',
  payment_method: 'Payment Method',
  payment_status: 'Payment Status',
  receipt: 'Receipt',
  yes: 'Yes',
  no: 'No',

  // Search and filters
  search_placeholder: 'Filter by supplier, notes, ref number or vehicle',
  category_placeholder: 'Category',
  all_categories: 'All Categories',

  // Sorting
  sort_last_created_desc: 'Last Created (Newest)',
  sort_last_created_asc: 'Last Created (Oldest)',
  sort_last_modified_desc: 'Last Modified (Newest)',
  sort_last_modified_asc: 'Last Modified (Oldest)',
  sort_custom: 'Custom',

  // Empty states
  no_expenses: 'No expenses found',
  no_expenses_search: 'No expenses match your search',
  start_tracking: 'Start tracking your expenses',

  // Results
  expenses_found_n: 'Costs found: {{n}}',

  // Mobile
  mobile_view_coming_soon: 'Mobile view coming soon',

  // Delete cost
  delete_cost: 'Delete Cost',
  delete_cost_description:
    'Are you sure you want to delete this cost? This action cannot be undone.',
  cost_deleted_successfully: 'Cost deleted successfully',
};

export default translations;
